import React, { useContext, useState } from "react";
import { ModalContext, RicosContext } from "./../../../ricos-context";
import { DropdownButton } from "../../components";
import { alignmentMap, getDefaultAlignment } from "./utils";
const NodeAlignmentButton = ({ toolbarItem, dataHook, id }) => {
  const { t, languageDir, isMobile } = useContext(RicosContext) || {};
  const modalService = useContext(ModalContext) || {};
  const [referenceElement, setReferenceElement] = useState(null);
  const getSelectedAlignment = () => toolbarItem?.attributes.nodeAlignment || getDefaultAlignment(languageDir);
  const getSelectedTextWrap = () => toolbarItem?.attributes.nodeTextWrap ?? true;
  const selectedAlignment = getSelectedAlignment();
  const SelectedAlignmentIcon = alignmentMap[`${selectedAlignment}`];
  const closeModal = () => modalService.closeModal(id);
  const onAlignmentClick = (alignment) => {
    toolbarItem.commands?.setAlignment({ value: alignment });
    closeModal();
  };
  const onTextWrapToggle = () => {
    toolbarItem.commands?.toggleTextWrap();
  };
  const onClick = () => {
    const div = document.createElement("div");
    div.textContent = `${id} ID OF MODAL, ${isMobile ? "MOBILE" : "DESKTOP"}, IS ALREADY OPEN? ${modalService.isModalOpen(id) ? "YES" : "NO"}`;
    document.body.appendChild(document.createElement("div"));
    modalService.isModalOpen(id) ? closeModal() : modalService?.openModal(id, {
      componentProps: {
        getSelectedAlignment,
        getSelectedTextWrap,
        onClick: onAlignmentClick,
        onTextWrapToggle
      },
      layout: isMobile ? "drawer" : "toolbar",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: modalService.isModalOpen(id),
      onClick,
      setRef: setReferenceElement,
      Icon: SelectedAlignmentIcon,
      tooltip: t("TextAlignmentButton_Tooltip")
    }
  );
};
var NodeAlignmentButton_default = NodeAlignmentButton;
export {
  NodeAlignmentButton_default as default
};
//# sourceMappingURL=NodeAlignmentButton.js.map
